var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"track",rawName:"v-track",value:({functionName: '新技术'}),expression:"{functionName: '新技术'}"}],staticClass:"technology",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"img-bg",attrs:{"src":require("@/assets/images/technology/technology-enter.png"),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34287f83","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/Technology.vue
// module id = null
// module chunks = 